// Wall — board ToileWallRest (`.wall`, `.row`), verbatim gap/padding.

.page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.wall {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 18px 22px;
}

.row {
    display: flex;
    gap: 8px;

    > div {
        flex: none;
    }
}

.sentinel {
    height: 1px;
}

// The Sheet floats fixed at the bottom (`Sheet.module.scss`), so the wall it sits over needs no
// bottom padding of its own on that surface; the side padding tightens for the same touch-first
// grip. Keyed on `[data-wall-surface="sheet"]` (`Wall.tsx`'s `isSheetSurface()`), not a width
// breakpoint (code-quality review F4 / least-and-simplest review §2.3) — a touch tablet gets the
// Sheet under the same rule the JS surface decision uses, and this padding must agree with which
// layer is actually mounted, not with the window's raw width.
:global(html[data-wall-surface='sheet']) {
    .wall {
        padding: 8px 14px 0;
    }
}

// The picture a visitor clicked elsewhere (`?basis`), first on their wall: ringed like an armed frame.
.arrived {
    border-radius: 4px;
    box-shadow: 0 0 0 1px var(--tl-accent), 0 0 32px color-mix(in srgb, var(--tl-accent) 22%, transparent);
}
